<template>
  <div class="page" v-loading="loading">
    <!--    导出  Export

    yesRefound
    noRefound
    -->
    <!--    订单详情   orderDetail-->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="对账周期：">
              <el-date-picker :default-time="['00:00:00', '23:59:59']" v-model="valueTime" type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                @change="handlePicker" class="w100"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="核对状态:">
              <!--          <el-input v-model="searchData.isSupplierVerify" placeholder="请输入分销商" clearable></el-input>-->
              <el-select clearable v-model="searchData.isSupplierVerify" placeholder="请选择" class="w100">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input clearable v-model="searchData.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="外部订单号:">
              <el-input clearable v-model="searchData.outOrderNo" placeholder="请输入外部订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型:">
              <el-select clearable v-model="searchData.VerifyOrderType" placeholder="请选择类型" class="w100">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <div class="flex">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" ref="tables" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column :selectable="checkSelectable" type="selection" width="50" fixed align="center">
      </el-table-column>
      <el-table-column label="核对状态" width="100" align="center">
        <template slot-scope="{row:{isSupplierVerify}}">
          {{ isSupplierVerify ? '已对账' : '未对账' }}
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="{row:{supplierOrderType}}">
          <el-tag v-if="supplierOrderType === 1" effect="dark" size="small" type="success">订单</el-tag>
          <el-tag v-if="supplierOrderType === 2" effect="warning" size="small" type="info">退款</el-tag>
          <el-tag v-if="supplierOrderType === 3" effect="dark" size="small" type="danger">退货</el-tag>
          <!--            <span v-if="scope.row.supplierOrderType === 1">订单 </span>-->
          <!--            <span v-if="scope.row.supplierOrderType === 2">退款  </span>-->
          <!--            <span v-if="scope.row.supplierOrderType === 3">退货 </span>-->
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" width="120" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span v-if="Array.isArray( scope.row.orderPurchases) &&  scope.row.orderPurchases.length > 0">{{-->
        <!--                            scope.row.orderPurchases[0].orderPurchaseNo-->
        <!--                          }}</span>-->

        <!--            &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="outOrderNo" label="外部订单号" width="120" align="center"></el-table-column>
      <!--        <el-table-column prop="supplierName" label="订单来源" width="120" align="center"></el-table-column>-->
      <el-table-column prop="productName" label="商品名称" width="120" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].productSkuName-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="productPrice" label="商品价格" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span-->
        <!--                            style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="quantity" label="数量" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName }}-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="amount" label="采购金额" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].unitPrice-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="creationTime" label="时间" align="center">
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:15px">
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"
        style="float: right"></el-pagination>
      金额合计: {{ totalAmount }}
      <el-button @click="verify" style="margin-left:50px;" type="primary" size="mini">核对完成
      </el-button>
    </div>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload,
  GetSupplierOrderList,
  ResellerVerify,
  SupplierSupplierVerify,
  ExportResellerOrder,
  ExportSupplierOrder
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  name: 'Detail',
  components: { Toolbar },
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      valueStatus: null,
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      supplierName: '',
      supplierId: null,
      totalAmount: null,
      SupplierVerifyOrderDto: [],
      options: [{
        value: true,
        label: '已核对'
      }, {
        value: false,
        label: '未核对'
      }],
      options1: [{
        value: 1,
        label: '订单'
      }, {
        value: 2,
        label: '退款'
      }, {
        value: 3,
        label: '退货'
      }],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        // orderNo: null,
        // VerifyStartTime: null,
        // VerifyEndTime: null,
        // productSkuName: null,
        // receivingName: null,
        // receivingMobile: null,
        // Status: 4,
        VerifyStartTime: null,
        VerifyEndTime: null,
        isSupplierVerify: null,
        VerifyOrderType: null,
        orderNo: '',
        outOrderNo: '',
        Id: null
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      verifyData: {},
      loading: false
    };
  },
  created() {
    console.log('审核退款', this.$route.query.id);
    if (this.$route.query.id) {
      this.searchData.Id = this.$route.query.id;
      this.supplierName = this.$route.query.name;
      this.supplierId = this.$route.query.id;
      // // this.orderId = this.$route.query.orderId;
      console.log('审核退款', this.searchData.Id, this.resellerName);
      // // this.getDetail(this.$route.query.Id)
      this.getTableList();
    } else {
      return this.$message.error('供应商Id,参数缺失')
    }

  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    checkSelectable(row) {
      return !row.isSupplierVerify;
    },
    getDetail(button, index, row) {
      console.log('row', row)
      // if (row.supplierOrderType === 1) {
      //   this.$router.push(
      //     `/OrderManagement/Purchasing/OrderDetail?id=${row.orderId}`
      //   );
      // }
      if (row.supplierOrderType === 2) {
        this.$router.push(`/AfterSalesService/RefoundMoney/AfterSaleDetail?Id=${row.id}&orderId=${row.orderId}`)
      }
      if (row.supplierOrderType === 3) {
        this.$router.push(`/AfterSalesService/RefoundProduct/Detail?id=${row.id}&orderId=${row.orderId}`)
      }
    },
    async export() {
      console.log('exp')
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      ExportSupplierOrder(this.searchData).then(res => {
        console.log('res', res);
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '供应商对账订单.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    async verify() {
      if (this.currentRow.length <= 0) {
        return this.$message.error('请选择要核对的订单')
      }

      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        this.verifyData.totalAmount = this.totalAmount
        this.verifyData.supplierId = this.supplierId
        this.verifyData.supplierName = this.supplierName

        this.verifyData.supplierVerifyOrderDtos = [];
        this.verifyData.supplierVerifyOrderDtos = this.SupplierVerifyOrderDto;
        console.log('this.verifyData', this.verifyData);
        // return;
        let res = await SupplierSupplierVerify(this.verifyData);
        console.log('rees', res);
        if (res.data.success) {
          this.verifyData = {}
          this.totalAmount = null
          this.currentRow = [];
          this.$refs.tables.clearSelection();
          this.$message.success('审核成功')
          await this.getTableList();
        } else {
          this.$message.error(res.data.error.message || '获取数据失败, 请重试')
        }

      }).catch(() => {
        console.log('er')
        this.verifyData = {}
        this.totalAmount = null
        this.currentRow = [];
        this.$refs.tables.clearSelection();
      });


    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      this.$router.push(
        `/Financial/SupplierFinancialManage/Detail?id=${row.id}`
      );
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await GetSupplierOrderList(this.searchData);
      setTimeout(() => {
        this.loading = false;
      }, 500)
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.error.message);
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.VerifyStartTime = null
        this.searchData.VerifyEndTime = null
      } else {
        this.searchData.VerifyStartTime = date[0]
        this.searchData.VerifyEndTime = date[1]
      }
    },
    resetFun() {

      this.searchData.PageIndex = 1;
      this.searchData.PageSize = 10;
      this.searchData.orderNo = '';
      this.searchData.outOrderNo = '';
      this.searchData.VerifyStartTime = null;
      this.searchData.VerifyEndTime = null;
      this.searchData.isSupplierVerify = null;
      this.searchData.VerifyOrderType = null;

      this.valueTime = [];

      this.getTableList();
    },
    selectCurrentRow(val) {
      // if (val.length > 0) {
      console.log(val);
      this.currentRow = val;
      let total = 0;
      let orderIds = []
      val.forEach(item => {
        // total += (item.amount*100)
        if (Number(item.supplierOrderType) === 1) {
          total -= (item.amount * 100)
        } else {
          total += (item.amount * 100)
        }
        orderIds.push({ supplierOrderType: item.supplierOrderType, orderId: item.id })
      })

      console.log('orderIds', orderIds);
      this.totalAmount = (total / 100);
      // this.SupplierVerifyOrderDto.supplierOrderType = [val.resellerOrderType];
      // this.SupplierVerifyOrderDto.orderId = val.id;
      this.SupplierVerifyOrderDto = orderIds;
      console.log(total)
      // }

    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

